<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_recruitment_content") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Company Link Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.companyLink')"
            v-model.trim="data.company_link"
            required
          />
          <!-- End:: Company Link Input -->

          <!-- Start:: Jobs Multi-Select -->
          <base-select-input
            col="6"
            :optionsList="activeJobs"
            :placeholder="$t('PLACEHOLDERS.selectJobs')"
            v-model="data.jobs"
          />
          <!-- End:: Jobs Multi-Select -->

          <!-- Start:: Description Arabic Input -->
          <base-input
            col="6"
            type="textarea"
            rows="5"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.description_ar"
            :maxlength="200"
            required
            @input="checkDescriptionArLength"
          />
          <!-- <small v-if="data.description_ar" class="col-6 text-muted">
            {{ data.description_ar.length }} / 200
          </small> -->
          <!-- End:: Description Arabic Input -->

          <!-- Start:: Description English Input -->
          <base-input
            col="6"
            type="textarea"
            rows="5"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.description_en"
            :maxlength="200"
            required
            @input="checkDescriptionEnLength"
          />
          <!-- <small v-if="data.description_en" class="col-6 text-muted">
            {{ data.description_en.length }} / 200
          </small> -->
          <!-- End:: Description English Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreateRecruitmentContent",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        company_link: null,
        jobs: [],
        description_ar: null,
        description_en: null,
      },
      activeJobs: [],
      // End:: Data Collection To Send
    };
  },

  methods: {
    checkDescriptionArLength() {
      if (this.data.description_ar && this.data.description_ar.length >= 200) {
        this.data.description_ar = this.data.description_ar.substring(0, 200);
      }
    },
    checkDescriptionEnLength() {
      if (this.data.description_en && this.data.description_en.length >= 200) {
        this.data.description_en = this.data.description_en.substring(0, 200);
      }
    },

    // Start:: Get Active Jobs
    async getActiveJobs() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "jobs",
          params: {
            page: 0,
            limit: 0,
            is_active: 1,
          },
        });
        this.activeJobs = res.data.data.data?.map((job) => ({
          id: job.id,
          name: job.name,
          value: job.id,
        }));
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },
    // End:: Get Active Jobs

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("company_link", this.data.company_link);
      REQUEST_DATA.append(`job_id`, this.data.jobs?.id);

      // Append multiple job IDs
      // if (this.data.jobs && this.data.jobs.length > 0) {
      //   this.data.jobs.forEach((job, index) => {
      //     REQUEST_DATA.append(`job_ids[${index}]`, job.id);
      //   });
      // }

      REQUEST_DATA.append("description[ar]", this.data.description_ar);
      REQUEST_DATA.append("description[en]", this.data.description_en);

      try {
        await this.$axios({
          method: "POST",
          url: `recruitment_contents`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/recruitment-contents/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    await this.getActiveJobs();
  },
};
</script>
